import { z } from "zod";

export const SupplyInfoSchema = z.object({
  name: z.string().nullable(),
  percentage: z.number().nullable(),
  levelStatus: z.string(),
  currentLevel: z.number(),
  maxLevel: z.number(),
});

export type SupplyInfo = z.infer<typeof SupplyInfoSchema>;

export const SuppliesDetailSchema = z.object({
  cyan: SupplyInfoSchema.nullable(),
  magenta: SupplyInfoSchema.nullable(),
  yellow: SupplyInfoSchema.nullable(),
  black: SupplyInfoSchema.nullable(),
});

export type SuppliesDetail = z.infer<typeof SuppliesDetailSchema>;

export const TrayDetailSchema = z.object({
  trayName: z.string().nullable(),
  paperName: z.string().nullable(),
  paperSize: z.string(),
  percentage: z.number().nullable(),
  capacityStatus: z.string(),
  currentCapacity: z.number(),
  maxCapacity: z.number(),
});

export type TrayDetail = z.infer<typeof TrayDetailSchema>;

export const MachineDetailSchema = z.object({
  machineId: z.number(),
  manufacturer: z.string(),
  /** 제품 모델명. 장비 사진을 찾는 데 쓰므로 별칭으로 덮어쓰면 안 된다. */
  modelName: z.string(),
  /** 화면에 보여줄 이름(별칭 우선). 이 값이 없는 서버와 붙으면 modelName 을 쓴다. */
  displayName: z.string().nullable().optional(),
  ipAddress: z.string(),
  runtime: z.number().nullable(),
  status: z.enum(["OFFLINE", "WARMUP", "ONLINE", "WORKING", "WARNING"]),
  supplies: SuppliesDetailSchema,
  trays: z.array(TrayDetailSchema),
});

export type MachineDetail = z.infer<typeof MachineDetailSchema>;
